import { getLotsForProduct } from './lotSystem';

/**
 * Resolve purchase cost metadata for a checkout line (cart → sale record).
 * Prefers cart/lot data over generic lot-pricing cache.
 */
export function resolveCheckoutLinePurchase(item, lotPricingData = {}, finalLotId = null) {
  const location = item.stockLocation || 'Principal';
  const productId = item.productId;

  const fromCart = Number(item.purchaseUnitPrice) || Number(item.lot?.purchaseUnitPrice) || 0;
  if (fromCart > 0) {
    return {
      purchaseUnitPrice: fromCart,
      batchNumber: item.lot?.batchNumber || item.batch?.batchNumber || lotPricingData.batchNumber || null,
      expirationDate: item.lot?.expirationDate || item.expirationDate || lotPricingData.expirationDate || null
    };
  }

  const lotId = finalLotId || item.lotId || item.lot?.id || lotPricingData.id || null;
  if (lotId && productId) {
    const lots = getLotsForProduct(productId, location);
    const matched = lots.find((lot) => String(lot.id) === String(lotId));
    if (matched && Number(matched.purchaseUnitPrice) > 0) {
      return {
        purchaseUnitPrice: Number(matched.purchaseUnitPrice),
        batchNumber: matched.batchNumber || null,
        expirationDate: matched.expirationDate || null
      };
    }
  }

  return {
    purchaseUnitPrice: Number(lotPricingData.purchaseUnitPrice) || 0,
    batchNumber: lotPricingData.batchNumber || null,
    expirationDate: lotPricingData.expirationDate || null
  };
}

/**
 * Sum of (sold price − catalog price) × qty for manually priced lines.
 */
export function sumSalePriceAdjustments(saleProducts = []) {
  if (!Array.isArray(saleProducts)) return 0;
  return saleProducts.reduce((sum, line) => {
    if (!line?.priceManuallySet) return sum;
    const sold = Number(line.sellingUnitPrice ?? line.price ?? 0);
    const catalog = Number(line.catalogSellingPrice ?? 0);
    const qty = Number(line.quantity ?? 0);
    if (!qty) return sum;
    return sum + (sold - catalog) * qty;
  }, 0);
}
